import ConfirmModal from '../../../components/ConfirmModal'

// Modal 2, `save-popup` (mr-6 spec S9.1): the list state's Save, which copies the saved scenario's
// values into the checked template (D20, D21). Title and body are the canvas text, verbatim
// (nodes 11943:534, 6429:3794). Geometry: save-popup frame, 486 x 260 (src/components/README.md, "frame layout").
const SAVE_POPUP_FRAME = { minHeight: 260, padX: 40, padTop: 46, padBottom: 48, titleSize: 20, titleLeading: 24, titleGap: 14, buttonWidth: 112 }

export default function OverwriteConfirmModal({ open, templateName, onConfirm, onClose, isLoading, error }) {
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      error={error}
      title="Overwrite confirmation"
      body={`Replace the settings in “${templateName}” with the current analysis settings? This can’t be undone.`}
      confirmLabel="Save"
      loadingLabel="Saving…"
      confirmClassName="bg-[#4AA52A] hover:bg-[#328C12]"
      width={486}
      panelBg="#F4FAEF"
      frame={SAVE_POPUP_FRAME}
    />
  )
}
